module.exports = __webpack_public_path__ + "img/product.80a7eabf.jpg";